import React from "react";
import pluralize from "pluralize";
import {
  Alert,
  AlertDescription,
  AlertIcon,
  useColorModeValue,
} from "@chakra-ui/react";
import { TaskContent } from "./TaskContent";

export type TaskStatusProps = {
  isCorrect: boolean;
  trialsRemaining: number;
  successMessage?: string;
  failureMessage?: string;
};

export function TaskStatus({
  isCorrect,
  trialsRemaining,
  successMessage = "Nicely done!",
  failureMessage = "Review the video or read the course to find the right information.",
}: TaskStatusProps) {
  return (
    <Alert
      variant="solid"
      bg={isCorrect ? "green.400" : "red.300"}
      _dark={{
        bg: isCorrect ? "green.300" : "red.200",
      }}
      mt="3"
      borderRadius="md"
    >
      <AlertIcon />
      <AlertDescription>
        <TaskContent>
          {isCorrect
            ? `**Correct.** ${successMessage}`
            : trialsRemaining > 0
            ? `**Try again.** (Solution available in ${pluralize(
                "attempt",
                trialsRemaining,
                true
              )}). ${failureMessage}`
            : `**Try again or click the "Show Solution" button above.** ${failureMessage}`}
        </TaskContent>
      </AlertDescription>
    </Alert>
  );
}
